import CodeEntry, { type CodeEntryRef } from "@/components/CodeEntry";
import { DialogButton } from "@/components/shared/DialogButton";
import logo from "@/assets/img/logo.svg";
import viewerBackground from "@/assets/img/backgrounds/viewer-background.webp";
import TopDecal from "@/assets/img/viewer/landing-top-sliver.svg?react";
import BottomDecal from "@/assets/img/viewer/landing-bottom-sliver.svg?react";
import { useEffect, useRef, useState } from "react";
import DownloadOnApple from "@/web/img/download-apple.svg?react";
import DownloadOnGoogle from "@/web/img/download-google-play.svg?react";
import Jobo from "@/assets/img/jobo-beta.webp";
import { useNavigate } from "react-router-dom";
import { formatRoomCode } from "@/util/Util";
import SendViewGameReq from "@/api/ViewerRequests";
import ToggleSwitch from "../components/ToggleSwitch";

export default function LandingPage()
{
    const navigate = useNavigate();
    const testCode = (roomID: string) => Boolean(/^[A-Z]{6}$/u.exec(roomID));

    const onSubmit = async (roomID: string): Promise<string | null> =>
    {
        if (!testCode(roomID)) return "Room not found";

        try
        {
            await SendViewGameReq(roomID, null);

            return null;
        }
        catch
        {
            return "Room not found";
        }
    };

    const codeRef = useRef<CodeEntryRef>(null);
    const [error, setError] = useState("");

    const submit = () =>
    {
        setError("");

        AssertIsset(codeRef.current, "where room code ref?");

        const rawRoomID = codeRef.current.value;

        const roomID = rawRoomID.replaceAll("-", "");

        onSubmit(roomID)
            .then((error) =>
            {
                if (error)
                {
                    setError(error);
                }
                else
                {
                    navigate(formatRoomCode(roomID));
                }
            })
            .catch(err => void Logger.log("ERROR:", err));
    };

    const [blurPhotos, setBlurPhotos] = useState(localStorage.getItem("blur_photos") === "1");
    const [blurHeadlines, setBlurHeadlines] = useState(localStorage.getItem("blur_headlines") === "1");

    useEffect(() =>
    {
        localStorage.setItem("blur_photos", blurPhotos ? "1" : "0");
        localStorage.setItem("blur_headlines", blurHeadlines ? "1" : "0");
    }, [blurPhotos, blurHeadlines]);


    return (
        <div
            className={Wind.style({
                height: "h-full",
                display: "flex",
                alignItems: "items-center",
                justifyContent: "justify-center"
            }).class}
            style={{
                backgroundImage: `url(${viewerBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
            }}
        >
            <div
                className={Wind.style({
                    height: "h-full",
                    width: "w-1/2",
                    display: "flex",
                    flexDirection: "flex-col",
                    alignItems: "items-center",
                    justifyContent: "justify-center",
                }).class}
            >
                <img
                    src={logo}
                    className={Wind.style({
                        width: "w-full",
                        maxWidth: "max-w-[37.5rem]",
                        marginBottom: "mb-12",
                    }).class}
                />
                <div
                    className={Wind.style({
                        display: "flex",
                        flexDirection: "flex-col",
                        width: "w-full",
                        maxWidth: "max-w-[26rem]",
                        marginLeft: "ml-auto",
                        marginRight: "mr-auto",
                        position: "relative",
                        "::before": {
                            position: "before:absolute",
                            display: "before:block",
                            height: "before:h-full",
                            width: "before:w-full",
                            inset: "before:inset-0",
                            backgroundColor: "before:bg-white",
                            transformScaleY: "before:scale-y-95",
                            transformScaleX: "before:scale-x-105",
                            zIndex: "before:z-[1]",
                        }
                    }).class}
                >
                    <TopDecal
                        className={Wind.style({
                            width: "w-full",
                            flex: "flex-[0_0_1.125rem]",
                            position: "relative",
                            zIndex: "z-10",
                            transformTranslateY: "translate-y-[1px]",
                        }).class}
                    />
                    <div
                        className={Wind.style({
                            display: "flex",
                            flexDirection: "flex-col",
                            alignItems: "items-center",
                            height: "h-full",
                            width: "w-full",
                            padding: "p-12",
                            backgroundColor: "bg-dark-blue",
                            position: "relative",
                            zIndex: "z-10",
                        }).class}
                    >
                        <div
                            className={Wind.style({
                                maxWidth: "max-w-[20rem]",
                                textAlign: "text-center",
                            }).class}
                        >
                            <h1
                                className={Wind.style({
                                    alignSelf: "self-start",
                                    fontFamily: "font-default",
                                    color: "text-white",
                                    fontSize: "text-[2rem]",
                                    fontWeight: "font-extrabold",
                                    marginBottom: "mb-6",
                                    textAlign: "text-left"
                                }).class}
                            >
                                Spectate Game
                            </h1>
                            <CodeEntry
                                ref={codeRef}
                                error={error}
                                className={Wind.style({
                                    width: "w-full",
                                    marginBottom: "mb-6"
                                }).class}
                                onChanged={() => void setError("")}
                                onEnter={() => void submit()}
                            />
                            <div
                                className={Wind.style({
                                    display: "flex",
                                    justifyContent: "justify-between",
                                    paddingBottom: "pb-2",
                                    gap: "gap-4",
                                    marginX: "-mx-4",
                                }).class}
                            >
                                <ToggleSwitch
                                    checked={blurPhotos}
                                    onChange={(value) =>
                                    {
                                        setBlurPhotos(value);
                                    }}
                                    label="Blur Photos"
                                />
                                <ToggleSwitch
                                    checked={blurHeadlines}
                                    onChange={setBlurHeadlines}
                                    label="Blur Headline"
                                />
                            </div>
                            <p>
                                <span
                                    className={Wind.style({
                                        color: "text-poppy-yellow",
                                        fontFamily: "font-default",
                                        fontSize: "text-sm",
                                        fontWeight: "font-normal",
                                        fontStyle: "italic",
                                        marginBottom: "mb-2",
                                        marginX: "-mx-4",
                                        display: "block",
                                    }).class}
                                >
                                    These settings apply to this session only.
                                    Content will appear blurred by default and reveal on click.
                                </span>
                            </p>
                            <DialogButton
                                text="Join"
                                color="sharp-red"
                                onClick={() => void submit()}
                                className={Wind.style({
                                    width: "w-28",
                                    height: "h-14",
                                    marginBottom: "mb-10",
                                    fontFamily: "font-default",
                                    fontSize: "text-xl",
                                    lineHeight: "leading-6",
                                }).class}
                            />

                            <div
                                className={Wind.style({
                                    display: "flex",
                                    justifyContent: "justify-center",
                                    alignItems: "items-center",
                                    gap: "gap-4",
                                    width: "w-full",
                                }).class}
                            >
                                <a
                                    href="https://apps.apple.com/us/app/realize-magazine/id1672985356"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <DownloadOnApple className="w-auto h-10" />
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.jumpbutton.realize"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <DownloadOnGoogle className="w-auto h-10" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <BottomDecal
                        className={Wind.style({
                            width: "w-full",
                            height: "h-auto",
                            position: "relative",
                            zIndex: "z-10"
                        }).class}
                    />
                </div>
                <div>
                    <script
                        async
                        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8823077351295808"
                        crossOrigin="anonymous"
                    >
                    </script>
                    {/* <!-- Spectator Ads --> */}
                    <ins
                        className="adsbygoogle"
                        style={{
                            display: "inline-block",
                            width: "316px",
                            height: "263px"
                        }}
                        data-ad-client="ca-pub-8823077351295808"
                        data-ad-slot="3811673646"
                    >
                    </ins>
                    <script>
                        (adsbygoogle = window.adsbygoogle || []).push(
                        {}
                        );
                    </script>
                </div>
            </div>
            <div className="fixed right-0 bottom-0">
                <img
                    src={Jobo}
                    className={
                        Wind.style({
                            width: "w-[6.438rem]",
                            height: "h-auto",
                            transformTranslateY: "translate-y-5"
                        }).class
                    }
                />
            </div>

        </div>

    );
}
